
import React from 'react';

import { I18n } from '@aws-amplify/core';

class ErrorPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {}
	}

	render() {
		return (
			<h1>
				{I18n.get('ERROR_PAGE_MESSAGE')}
			</h1>
		)
	}
}

export default ErrorPage;
